export const eventsStyle = {
    eventDisplay: 'block',
    eventTextColor: '#FAFAFA'
}